import { Outlet } from '@tanstack/react-router';
import Logo from './assets/logo.svg?react';
import styles from './Layout.module.scss';
import { Footer } from './components';

export const Layout = () => (
  <div className={styles.wrapper}>
    <Logo />
    <Outlet />
    <Footer />
  </div>
);
